exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* stylelint-disable */\n\n/* ==========================================================================\n   Toolbar\n   ========================================================================== */\n.toolbar {\n  display: flex;\n  width: 100%;\n  margin-top: 20px;\n  border-radius: 0 0 3px 3px; }\n\n/* Density\n   ========================================================================== */\n.toolbar--density-none {\n  padding: 0; }\n\n.toolbar--density-compact {\n  padding: 10px 30px; }\n\n.toolbar--density-cozy {\n  padding: 20px 30px; }\n\n.toolbar--density-comfortable {\n  padding: 20px 60px; }\n\n/* Align items\n   ========================================================================== */\n.toolbar--align-flex-start {\n  align-items: flex-start; }\n\n.toolbar--align-center {\n  align-items: center; }\n\n.toolbar--align-flex-end {\n  align-items: flex-end; }\n\n.toolbar--align-baseline {\n  align-items: baseline; }\n\n.toolbar--align-stretch {\n  align-items: stretch; }\n\n/* Justify content\n   ========================================================================== */\n.toolbar--justify-flex-start {\n  justify-content: flex-start; }\n\n.toolbar--justify-center {\n  justify-content: center; }\n\n.toolbar--justify-flex-end {\n  justify-content: flex-end; }\n\n.toolbar--justify-space-between {\n  justify-content: space-between; }\n\n.toolbar--justify-space-around {\n  justify-content: space-around; }\n\n/* Backgrounds\n   ========================================================================== */\n.toolbar--background-transparent {\n  background-color: transparent; }\n\n.toolbar--background-light {\n  background-color: #f2f2f2; }\n\n.toolbar--background-dark {\n  background-color: #c2c2c2; }\n\n@media (max-width: 767px) {\n  .toolbar--density-compact {\n    padding: 10px 20px; }\n  .toolbar--density-cozy {\n    padding: 20px 20px; }\n  .toolbar--density-comfortable {\n    padding: 20px 20px; } }\n", ""]);

// exports
exports.locals = {
	"color-groups": "base | colors | primary | semantic | chart",
	"colors-white": "#fff",
	"colors-red": "#f54545",
	"colors-green": "#6acb4c",
	"colors-body-color": "#363636",
	"colors-grey-90": "#444",
	"colors-grey-80": "#666",
	"colors-grey-70": "#858484",
	"colors-grey-60": "#a4a4a4",
	"colors-grey-50": "#c2c2c2",
	"colors-grey-40": "#ddd",
	"colors-grey-30": "#ececec",
	"colors-grey-20": "#f2f2f2",
	"colors-grey-10": "#f8f8f8",
	"colors-black": "#000",
	"base-brown-100": "#343230",
	"base-brown-80": "#474340",
	"base-brown-60": "#61554c",
	"base-brown-40": "#998673",
	"base-brown-20": "#c1aa95",
	"base-earth-100": "#bbb6af",
	"base-earth-80": "#c7c1b8",
	"base-earth-60": "#d7cebf",
	"base-earth-40": "#eae4db",
	"base-earth-20": "#e9e7db",
	"base-earth-10": "#f7f5eb",
	"primary-romantic-purple-base": "#834ba2",
	"primary-romantic-purple-dark": "#5a3770",
	"primary-romantic-purple-light": "#ab83c4",
	"primary-sky-blue-base": "#25b8d2",
	"primary-sky-blue-dark": "#1797ae",
	"primary-sky-blue-light": "#57d0dd",
	"primary-mint-base": "#3fc798",
	"primary-mint-dark": "#2cab7f",
	"primary-mint-light": "#79dbb5",
	"primary-grassy-base": "#96cb4c",
	"primary-grassy-dark": "#81a03c",
	"primary-grassy-light": "#b7dd7a",
	"primary-desert-sunset-base": "#eca03e",
	"primary-desert-sunset-dark": "#c2802a",
	"primary-desert-sunset-light": "#fbc75c",
	"primary-salmon-base": "#f57b45",
	"primary-salmon-dark": "#d45e2a",
	"primary-salmon-light": "#ef9a78",
	"semantic-color-primary": "#f57b45",
	"semantic-color-primary-hovered": "#d45e2a",
	"semantic-color-primary-active": "#ef9a78",
	"semantic-color-secondary": "#25b8d2",
	"semantic-color-secondary-hovered": "#1797ae",
	"semantic-color-secondary-active": "#57d0dd",
	"semantic-color-light": "#fff",
	"semantic-color-light-hovered": "#fff",
	"semantic-color-light-active": "#fff",
	"semantic-color-dark": "#f8f8f8",
	"semantic-color-dark-hovered": "#f2f2f2",
	"semantic-color-dark-active": "#f8f8f8",
	"semantic-color-error": "#f54545",
	"semantic-color-success": "#6acb4c",
	"semantic-color-warning": "#eca03e",
	"semantic-color-instruction": "#25b8d2",
	"semantic-color-info": "#834ba2",
	"semantic-color-hint": "#c2c2c2",
	"chart-first": "#25b8d2",
	"chart-second": "#f57b45",
	"chart-third": "#96cb4c",
	"chart-fourth": "#eca03e",
	"chart-fifth": "#3fc798",
	"chart-sixth": "#ab83c4",
	"chart-seventh": "#c1aa95",
	"chart-eighth": "#c2c2c2"
};